import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

export const walletBackendUrl = import.meta.env.VITE_WALLET_BACKEND_URL;
export const gmapsKey = import.meta.env.VITE_GMAPS_KEY;
export const mapboxStyle = import.meta.env.VITE_MAPBOX_STYLE;
export const mapboxToken = import.meta.env.VITE_MAPBOX_TOKEN;
export const firebaseApiKey = import.meta.env.VITE_FIREBASE_API_KEY;
export const firebaseAuthDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
export const firebaseProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
export const firebaseStorageBucket = import.meta.env
  .VITE_FIREBASE_STORAGE_BUCKET;
export const firebaseMessagingSenderId = import.meta.env
  .VITE_FIREBASE_MESSAGING_SENDER_ID;
export const firebaseAppId = import.meta.env.VITE_FIREBASE_APP_ID;
export const firebaseMeasurementId = import.meta.env
  .VITE_FIREBASE_MEASUREMENT_ID;
export const firebaseDatabaseUrl = import.meta.env.VITE_FIREBASE_DATABASE_URL;
export const featureFlags = {
  ios: import.meta.env.VITE_IOS_FLAGS,
  android: import.meta.env.VITE_ANDROID_FLAGS,
  web: import.meta.env.VITE_WEB_FLAGS,
  default: import.meta.env.VITE_DEFAULT_FLAGS,
};
export const mercadopagoPublicKey = import.meta.env.VITE_MERCADOPAGO_PUBLIC_KEY;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const NODE_ENV = import.meta.env.PROD ? 'production' : 'development';

export const openpayMerchantId = import.meta.env.VITE_OPENPAY_MERCHANT_ID;
export const openpayPublicKey = import.meta.env.VITE_OPENPAY_PUBLIC_KEY;
export const openPaySandboxMode =
  import.meta.env.VITE_OPENPAY_SANDBOX_MODE === 'true';

// GrowthBook client keys
export const GROWTHBOOK_CLIENT_KEYS = {
  ios: import.meta.env.VITE_GROWTHBOOK_IOS_CLIENT_KEY,
  android: import.meta.env.VITE_GROWTHBOOK_ANDROID_CLIENT_KEY,
  web: import.meta.env.VITE_GROWTHBOOK_WEB_CLIENT_KEY,
};

export const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;

// Jwt
export const JWT_SECRET = import.meta.env.VITE_JWT_SECRET;

// Redis
export const UPSTASH_REDIS_REST_URL = import.meta.env
  .VITE_UPSTASH_REDIS_REST_URL;
export const UPSTASH_REDIS_REST_TOKEN = import.meta.env
  .VITE_UPSTASH_REDIS_REST_TOKEN;

const API_URL = import.meta.env.VITE_PARI_API_URL;
const WHITELABEL_API_URL = import.meta.env.VITE_WHITELABEL_API_URL;

const API_URL_BY_SUBDOMAIN = {
  [AppSubdomains.Pari]: API_URL,
  [AppSubdomains.Homebar]: WHITELABEL_API_URL,
  [AppSubdomains.Terea]: API_URL,
};

const buildApiBaseUrl = () => {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);

  return API_URL_BY_SUBDOMAIN[subdomain] ?? API_URL;
};

export const backendUrl = buildApiBaseUrl();
